import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useExperienceTheme } from '../context/ExperienceThemeContext';

const FloatingMaydayButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentTheme } = useExperienceTheme();
  const t = currentTheme?.terminology || {};

  // Don't show on login, signup, mayday display page, or theme selection
  const hiddenPaths = ['/login', '/signup', '/mayday', '/choose-theme'];
  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <button
      onClick={() => navigate('/mayday')}
      data-testid="floating-mayday-btn"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 rounded-full bg-red-600 hover:bg-red-500 shadow-lg shadow-red-500/30 flex items-center justify-center transition-all hover:scale-110 active:scale-95 animate-pulse-slow"
      aria-label={t.mayday || 'Emergency Mayday'}
    >
      <AlertTriangle className="w-8 h-8 text-white" />
    </button>
  );
};

export default FloatingMaydayButton;
